<template>
  <div class="ways">
    <div class="container">
      <span class="ways__title">Что нужно знать о коронавирусе</span>
      <span class="ways__subtitle">Пути передачи</span>
      <div class="ways-elements">
        <div class="ways-element">
          <div class="ways-element-icon"><Ways1/></div>
          <span class="ways-element-text">Воздушно-капельным путём (при кашле, чихании, разговоре)</span>
        </div>
        <div class="ways-element">
          <div class="ways-element-icon"><Ways2/></div>
          <span class="ways-element-text">Воздушно-пылевым путём (с пылевыми частицами в воздухе)</span>
        </div>
        <div class="ways-element">
          <div class="ways-element-icon"><Ways3/></div>
          <span class="ways-element-text">Контактно-бытовым путём (через рукопожатия, предметы обихода)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ways1 from '@/assets/svg/infographics/ways-icon1.svg';
import Ways2 from '@/assets/svg/infographics/ways-icon2.svg';
import Ways3 from '@/assets/svg/infographics/ways-icon3.svg';

export default {
  components: {
    Ways1,
    Ways2,
    Ways3,
  }
}
</script>

<style lang="scss" scoped>
.ways {
  padding: 60px 0;
  background-color: #f2f7f9;
  &__title {
    display: block;
    font-size: 35px;
    color: #0096c8;
    font-weight: bold;
    text-align: center;
  }
  &__subtitle {
    display: block;
    font-weight: bold;
    color: #040404;
    font-size: 35px;
    text-align: center;
    margin-bottom: 105px;
  }
  &-elements {
    display: flex;
    justify-content: space-between;
  }
  &-element {
    width: 32%;
    box-shadow: 0 3px 8px rgba(82, 121, 146, 0.23);
    border-radius: 3px;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 25px;
    padding-top: 93px;
    height: 179px;
    position: relative;
    &-icon {
      border-radius: 50%;
      box-shadow: 0 3px 22px rgba(82, 121, 146, 0.34);
      width: 146px;
      height: 146px;
      left: 50%;
      margin-left: -73px;
      top: -73px;
      position: absolute;
    }
    &-text {
      display: block;
      text-align: center;
      font-size: 15px;
    }
  }
}
@media screen and (max-width: 767px) {
  .ways {
    padding: 50px 0;
    &__title {
      font-size: 25px;
    }
    &__subtitle {
      font-size: 25px;
    }
    &-elements {
      flex-wrap: wrap;
    }
    &-element {
      margin: 0 auto;
      width: 100%;
      margin-bottom: 95px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
